module.exports = __webpack_public_path__ + "img/BB-Master-Talento-2020.f056357d.jpg";